<script setup>
import { useQuality } from '@/composables/useQuality'
import { useAbility } from '@casl/vue'
import { useRoute, useRouter } from 'vue-router'

// Module 17 (§9.4) — "grafik trend, reuse TrendChart.vue" (literal
// blueprint). TrendChart.vue (Module 13) 100% dipakai apa adanya —
// Indicator scoring lewat Assessment Engine berarti trend-nya SUDAH ada
// di endpoint generik GET /assessment-templates/{template}/trend,
// subject=unit indikator ini. Tidak ada endpoint/komponen trend baru.
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Indicator',
  },
})

const route = useRoute('quality-indicators-id')
const router = useRouter()
const ability = useAbility()
const { indicator, loading, saving, fetchIndicator, recordIndicatorValue } = useQuality()

onMounted(() => fetchIndicator(route.params.id))

const dialog = ref(false)
const form = ref({ period: '', value: '' })
const error = ref('')

const openRecord = () => {
  form.value = { period: new Date().toISOString().slice(0, 7) + '-01', value: '' }
  error.value = ''
  dialog.value = true
}

const save = async () => {
  error.value = ''
  try {
    await recordIndicatorValue(route.params.id, form.value)
    dialog.value = false
    await fetchIndicator(route.params.id)
  } catch (e) {
    error.value = e?.data?.message ?? 'Gagal menyimpan nilai indikator.'
  }
}
</script>

<template>
  <div>
    <div class="d-flex align-center gap-3 mb-4">
      <VBtn
        icon="ri-arrow-left-line"
        variant="text"
        @click="router.push({ name: 'quality-indicators' })"
      />
      <div>
        <h4 class="text-h4 font-weight-bold">
          {{ indicator?.name }}
        </h4>
        <p class="text-body-2 text-medium-emphasis mb-0">
          {{ indicator?.category?.name }} — {{ indicator?.unit?.name }}
        </p>
      </div>
    </div>

    <VProgressLinear
      v-if="loading"
      indeterminate
      color="primary"
      class="mb-4"
    />

    <template v-else-if="indicator">
      <VCard class="mb-4">
        <VCardTitle class="pa-6 pb-0 d-flex align-center justify-space-between">
          Trend Bulanan
          <VBtn
            v-if="ability.can('manage', 'Indicator')"
            size="small"
            prepend-icon="ri-add-line"
            @click="openRecord"
          >
            Catat Nilai
          </VBtn>
        </VCardTitle>
        <VCardText class="pa-6">
          <p
            v-if="indicator.target_value"
            class="text-body-2 text-medium-emphasis"
          >
            Target: {{ indicator.target_value }}
          </p>
          <TrendChart
            :template-id="indicator.assessment_template_id"
            subject-type="unit"
            :subject-id="indicator.unit_id"
          />
        </VCardText>
      </VCard>
    </template>

    <VDialog
      v-model="dialog"
      max-width="480"
      persistent
    >
      <VCard>
        <VCardTitle class="pa-6 pb-0">
          Catat Nilai Bulanan
        </VCardTitle>
        <VCardText class="pa-6">
          <VAlert
            v-if="error"
            type="error"
            variant="tonal"
            density="compact"
            class="mb-4"
          >
            {{ error }}
          </VAlert>
          <VRow>
            <VCol cols="12">
              <VTextField
                v-model="form.period"
                type="date"
                label="Periode (Bulan) *"
              />
            </VCol>
            <VCol cols="12">
              <VTextField
                v-model="form.value"
                type="number"
                label="Nilai *"
              />
            </VCol>
          </VRow>
        </VCardText>
        <VCardActions class="pa-6 pt-0">
          <VSpacer />
          <VBtn
            variant="tonal"
            color="secondary"
            :disabled="saving"
            @click="dialog = false"
          >
            Batal
          </VBtn>
          <VBtn
            color="primary"
            :loading="saving"
            @click="save"
          >
            Simpan
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </div>
</template>
